import { useMemo } from 'react';
import { trpc } from '@/lib/trpc';
import type { LandingMe } from '../../../../shared/types/people-landing';

/** Datos de la persona logueada para la landing (Fase 4). 10 min de cache, como el backend. */
export function useLandingMe(enabled = true) {
  return trpc.peopleLanding.getMe.useQuery(undefined, {
    enabled,
    staleTime: 10 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
}

/** Fotos de Workspace (cache S3 24 h en el backend). Fallback: iniciales. */
export function useLandingAvatars(emails: string[]) {
  const clean = useMemo(
    () => Array.from(new Set(emails.map((e) => e.trim().toLowerCase()).filter((e) => e.endsWith('@winclap.com')))).slice(0, 20),
    [emails.join('|')] // eslint-disable-line react-hooks/exhaustive-deps
  );
  return trpc.peopleLanding.getAvatars.useQuery(
    { emails: clean },
    { enabled: clean.length > 0, staleTime: 60 * 60 * 1000, refetchOnWindowFocus: false }
  );
}

/** Regla de los tres estados (doc §0): cada bloque decide si aplica al que mira. */
export function isLandingBlockVisible(type: string, me: LandingMe | undefined): boolean {
  if (type === 'progress') return !!me?.onboarding;
  // "Tu equipo" es para todos (pedido Sol 09/09): basta estar en el community map.
  if (type === 'team') return !!(me?.onboarding || me?.team);
  return true;
}
